"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContainerContext = exports.rootContainer = void 0;
const react_1 = __importDefault(require("react"));
const inversify_1 = require("inversify");
exports.rootContainer = new inversify_1.Container();
exports.ContainerContext = react_1.default.createContext(exports.rootContainer);
//# sourceMappingURL=container-context.js.map